import * as React from "react";
import "./styles/FooterComponent.scss";
import { FooterPayload, InfoPagePayload, Locale } from "../contenful/types";
import FooterTextButton from "./FooterTextButton";
import LanguageMenu from "../ui/language/LanguageMenu";
import { WindowSize } from "../settings/SettingsReducer";
import { getContainer } from "../ioc/IOCSetup";
import ImageArea from "./ImageArea";
import FooterText from "./FooterText";
import AppInstallComponent from "../ui/AppInstallComponent";
import DynamicContentView from "../landingpage/pagesection/DynamicContentView";
import { AppContext, MenuPosition } from "../http/protocol";

interface Props {
  windowSize: number;
  footer: FooterPayload;
  onClick: (nameId: string) => void;
  loggedIn: boolean;
  position?: MenuPosition
  appContext?: AppContext;
}

export class FooterComponent extends React.Component<Props> {
  locales: Array<Locale> | undefined;
  constructor(props: Props) {
    super(props);

    this.locales = getContainer().getSettingsService().getLocalesData();
    this.renderHighlight();
  }

  renderHighlight = () => {
    let list = this.props.footer?.infoPagesHighlighted;
    if (list) {
      return (
        <div className={"footer-row"}>
          {list
            .filter((i) => !!(i?.id || i?.nameId))
            .map((item: InfoPagePayload, index) => {
              return (
                <FooterTextButton
                  key={index}
                  nameId={item?.nameId ?? item?.id}
                  highlight={true}
                  onClick={this.props.onClick}
                  title={item?.nameId ?? item?.id}
                />
              );
            })}
        </div>
      );
    } else {
      return null;
    }
  };

  renderNoneHighLight = () => {
    let list = this.props.footer?.infoPages;
    if (list) {
      return (
        <div className={"footer-row"}>
          {list.map((item: InfoPagePayload, index) => {
            return (
              <FooterTextButton
                key={index}
                nameId={item?.nameId ?? item?.id}
                highlight={false}
                onClick={this.props.onClick}
                title={item?.nameId ?? item?.id}
              />
            );
          })}
        </div>
      );
    } else {
      return null;
    }
  };

  render() {
    return (
      <footer className={"footer-container"}>
        <div className={"linkContainer"}>
          {this.props.position == MenuPosition.ABSOLUTE && this.props.loggedIn &&
          this.locales &&
          this.locales.length > 1 &&
          this.props.windowSize > WindowSize.WIDTH_XS ? (
            <div className={"languageWrapper hide-in-context"}>
              <LanguageMenu inNavMenu={false} />
            </div>
          ) : null}
          <div className={"appIconWrap"}>
            <div className={"footer-row"}>
            {this.props.appContext != AppContext.GLIFE && 
              <AppInstallComponent />
            }
            </div>
          </div>
          <div className={"linkWrap"}>
            {this.renderHighlight()}
            {this.renderNoneHighLight()}
          </div>
          {this.props.position == MenuPosition.ABSOLUTE && this.props.loggedIn &&
          this.locales &&
          this.locales.length > 1 &&
          this.props.windowSize == WindowSize.WIDTH_XS ? (
            <div className={"languageWrapper"}>
              <LanguageMenu inNavMenu={false} />
            </div>
          ) : null}
          {this.props.footer?.text && <FooterText footer={this.props.footer} />}
          {this.props.footer?.images && <ImageArea footer={this.props.footer} />}
        </div>
        {this.props.footer?.dynamicContent && (
          <div className="footer-dynamic-content">
            <DynamicContentView
              dynamicContent={this.props.footer?.dynamicContent}
              loggedIn={this.props.loggedIn}
              isFooter={true}
            />
          </div>
        )}
      </footer>
    );
  }
}

export default FooterComponent;
